export function getBuyLimits() {
  const minBuy = process.env['NEXT_PUBLIC_MIN_BUY'];
  const maxBuy = process.env['NEXT_PUBLIC_MAX_BUY'];

  if (!minBuy) {
    throw new Error('NEXT_PUBLIC_MIN_BUY is not set');
  }

  if (!maxBuy) {
    throw new Error('NEXT_PUBLIC_MAX_BUY is not set');
  }

  return { minBuy: parseInt(minBuy), maxBuy: parseInt(maxBuy) };
}
